import apiClient from "../lib/apiClients";
import { DirectorFeedback } from "types";

const BASE = "/director";

const buildQuery = (params?: Record<string, any>) => {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, String(v));
  });
  const s = qs.toString();
  return s ? `?${s}` : "";
};

export interface DirectorFeedbackListParams {
  model?: string;
  object_id?: string | number;
  feedback_type?: string;
  is_directive?: boolean;
  status?: string;
  author_id?: string;
  admin_unit_id?: string;
  include_replies?: boolean;
}

export const fetchDirectorFeedbacks = async (
  params?: DirectorFeedbackListParams,
) => {
  const response = await apiClient.get<DirectorFeedback[]>(
    `${BASE}/director-feedbacks/${buildQuery(params)}`,
  );
  return response.data;
};

export const fetchDirectorFeedbackById = async (id: string) => {
  const response = await apiClient.get<DirectorFeedback>(
    `${BASE}/director-feedbacks/${id}/`,
  );
  return response.data;
};

// Create a comment / feedback / directive (or a reply when `parent` is set).
// When a file is attached, send as multipart (the default JSON Content-Type is
// overridden so axios sets the multipart boundary).
export const addDirectorFeedback = async (
  data: DirectorFeedback & { file?: File | null },
) => {
  const hasFile = data?.file instanceof File;
  if (!hasFile) {
    const { file, ...rest } = data || {};
    const response = await apiClient.post(
      `${BASE}/director-feedbacks/`,
      rest,
    );
    return response.data;
  }
  const fd = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === "file" && value instanceof File) {
      fd.append("file", value);
      return;
    }
    if (typeof value === "object") return;
    fd.append(key, String(value));
  });
  const response = await apiClient.post(`${BASE}/director-feedbacks/`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// PATCH a feedback (e.g. mark a directive acknowledged / resolved).
export const updateDirectorFeedback = async (
  id: string,
  data: Partial<DirectorFeedback>,
) => {
  const response = await apiClient.patch(
    `${BASE}/director-feedbacks/${id}/`,
    data,
  );
  return response.data;
};
